import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import HomePage from "@/pages/HomePage";
import TeamPage from "@/pages/TeamPage";
import TheHomePage from "@/pages/TheHomePage";
import TheFieldPage from "@/pages/TheFieldPage";
import ContactPage from "@/pages/ContactPage";
import Header from "@/components/Header";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/the-home" element={<TheHomePage />} />
            <Route path="/the-field" element={<TheFieldPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
